import React, { useContext, useMemo, useEffect } from "react";
import { useSelector } from "react-redux";
import { DataContext } from "../../components/common/dataProvider";
import PageContent from "../../components/Styles/PageContent";
import PageLayout from "../../components/Styles/PageLayout";
import Ticket from "../../components/Ticket";
import { getEvent } from "../EventPage/util";
import slugify from "../../components/common/slugify";
import { Button, Container, Text, Title } from "@mantine/core";
import { useParams, useNavigate } from "react-router";
import { STATE_CULTURE } from "../../common/state";

const TicketPage = () => {
  const { language, culture } = useSelector((state) => ({
    language: state.language,
    culture: state.cookies[STATE_CULTURE],
  }));
  const id = useParams().id;
  const navigate = useNavigate();
  const { data, eventFilter } = useContext(DataContext);
  const config = useSelector((state) => state.config);
  const ticketData = config.ticketConfigurator;
  const event = useMemo(() => getEvent(data, id), [data, id]);
  const configurator = config?.ticketConfigurator.find(
    (el) => slugify(el.slug) === id
  );

  useEffect(() => {
    if (config && configurator && typeof window !== "undefined") {
      const title = configurator?.translations?.find(
        (t) => t.culture === culture
      )?.name;
      document.title = title
        ? `${title} - ${config?.shopName}`
        : `${configurator?.name} - ${config?.shopName}`;
    }
  }, [config, configurator]);

  if (!configurator || configurator?.disabled)
    return (
      <PageLayout>
        <PageContent>
          <Container
            style={{ textAlign: "center", margin: "3rem 0", maxWidth: "100%" }}
          >
            <Title mb="lg" order={1}>
              {language.CouldNotFindEventHeader}
            </Title>
            <Text component="p" mb="lg">
              {language.CouldNotFindEventText}
            </Text>
            <Button
              component="a"
              onClick={() => navigate("/")}
              className="mantine-Primary-btn"
              variant="filled"
              size="md"
              radius="sm"
              color="indigo"
            >
              {language.BackToHomepage}
            </Button>
          </Container>
        </PageContent>
      </PageLayout>
    );

  return (
    <PageLayout>
      <PageContent>
        <Ticket
          shopName={config.shopName}
          event={event}
          filter={eventFilter}
          ticketData={ticketData}
        />
      </PageContent>
    </PageLayout>
  );
};

export default TicketPage;
